import axiosInterceptor from './axiosInterceptor'

const deleteMeetingData = async (selectedRows) => { 
    const api = process.env.REACT_APP_BACKEND_KEY
    try{ 
        const response = await axiosInterceptor.post(`${api}/delete`, selectedRows, {
            credentials: 'include'
        })
        console.log("Response: ", response.data)
    } catch(error){
        console.error(error)
    }
}

export default deleteMeetingData